// Bump this every time you deploy a meaningful change.
// The value is shown in the sidebar so you can confirm VPS has the latest build.
export const APP_VERSION = "2.3.0";
export const BUILD_DATE  = "2026-10-15";
